export default {
  zh: {
    leads: '潜在客户',
    accounts: '客户',
    marketingMaterial: '营销',
    order: '订单',
    priceSetting: '价格设置',
    trackOrders: '发货单',
    trackOrderDetail: '发货单详情',
  },
  en: {
    leads: 'Leads',
    accounts: 'Accounts',
    marketingMaterial: 'Marketing Material',
    order: 'Order',
    priceSetting: 'Price Setting',
    trackOrders: 'Track Orders',
    trackOrderDetail: 'Track Order Detail',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/global/pageTitle.js